<template>
  <section :id="data.id" class="bg-gray-lighten3 py-10 xl:py-14">
    <div class="container">
      <div
        class="relative flex aspect-[327/200] items-center justify-center xl:aspect-[1344/700] 3xl:aspect-[1824/869]"
        @click="isVideoShowed = true"
      >
        <img
          v-if="!isVideoShowed"
          :src="`http://img.youtube.com/vi/${videoId}/maxresdefault.jpg`"
          class="l-0 t-0 absolute z-0 h-full w-full object-cover"
        />
        <UiIcon
          v-if="!isVideoShowed"
          icon="youtube"
          class="z-1 relative h-auto w-[68px] xl:w-[136px]"
        />
        <RichVideo
          v-if="isVideoShowed"
          :id="videoId"
          :muted="false"
          container-size
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import RichVideo from '~/components/RichVideo.vue';

interface Props {
  data?: any;
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const videoId = computed(() => {
  if (!props.data.link) return undefined;

  const url = new URL(props.data.link);
  const isYTBrowserLink = url.pathname === '/watch';
  return isYTBrowserLink
    ? url.searchParams.get('v')
    : url.pathname.replace('/', '');
});
const isVideoShowed = ref(false);
</script>
<style lang="scss" scoped>
svg {
  color: red;
}
</style>
